import React from "react";
import classNames from "classnames";

import { Row, Column } from "components/Layout";
import NTMButton from "components/Buttons/NTMButton";
import Checkbox from "components/Checkbox";
import { settings as SETTINGS } from "../../constants";


export default function SettingItem({ containerScope, settingItem, onChange, setting = {}, onDelete, className }) {

    function getField(value) {
        if (settingItem.options) {
            return <select value={value}
                onChange={({ target }) => {
                    onChange(target.value);
                }}
                {...settingItem.props}>
                {settingItem.options.map(opt => <option key={opt.value}
                    value={opt.value}>
                    {opt.name || opt.value}
                </option>)}
            </select>;
        }
        if (settingItem.type === "textarea") {
            return <textarea value={value}
                onChange={({ target }) => onChange(target.value)}
                {...settingItem.props}>
            </textarea>;
        }
        if (settingItem.type === "boolean") {
            return <Checkbox color={"red"} checked={value === "true"} onCheck={e => onChange(e.target.checked)} />;
        }
        return <input type={settingItem.type}
            value={value || ""}
            onChange={({ target }) => onChange(target.value)}
            {...settingItem.props}
        />;
    }

    function isDeletable() {
        if (settingItem.deletable) return true;
        if (setting.scope !== containerScope) return false;
        if (setting.scope === SETTINGS.scopes.PROJECT &&
            [SETTINGS.scopes.DEVICE_PROJECT_TYPE, SETTINGS.scopes.PROJECT_TYPE].includes(settingItem.scope)) return true;
        if (setting.scope === SETTINGS.scopes.DEVICE &&
            [SETTINGS.scopes.DEVICE_PROJECT, SETTINGS.scopes.DEVICE_PROJECT_TYPE, SETTINGS.scopes.DEVICE_TYPE].includes(settingItem.scope)) return true;
        return false;
    }

    return <Row className={classNames("item", className)}>
        <Column>
            <label>{settingItem.label}</label>
            <div>{settingItem.description}</div>
        </Column>
        {getField(setting.value)}
        <div style={{ width: 40 }}>
            {isDeletable() && setting.id && <NTMButton primary onClick={() => onDelete(setting.id)}><i className="fa fa-trash" aria-hidden="true" /></NTMButton>}
        </div>
    </Row>

}
